import * as React from "react"
import {Helmet} from "react-helmet-async";
import {Box} from "@mui/material";
import {AlertSeeker} from "@ui-seeker/core";


function PageBodyMessages({ messages=[] }) {
    return messages.map(({ title, message, ...props }, idx) => <AlertSeeker
        key={idx}
        disableAccordion
        severity="warning"
        title={title}
        {...props}
        sx={{ mb: 1, ...props?.sx }}
    >
        {message}
    </AlertSeeker>)
}

// Page body under the shell header: browser tab title, banners and the filters slot.
// The page title and its actions are not here — they live in the shell header.
export default function AppPageBody({ head='', globalMessages=[], filters=null, children }) {
    return <>
        <Helmet>
            <title>{head}</title>
            <meta name="robots" content="noindex, nofollow" />
            <meta name="googlebot" content="noindex, nofollow" />
        </Helmet>

        { !!globalMessages.length && <PageBodyMessages messages={globalMessages} /> }

        { filters && <Box sx={{ mb: 2 }}>{filters}</Box> }

        {children}
    </>
}
